var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgO2Uk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 43,
    viewBox: "0 0 45 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16468_230883",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H44.0981V42.328H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16468_230883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.945 34.4651C8.54662 34.4651 0.949219 26.8148 0.949219 17.3383C0.949219 7.86168 8.54662 0.211426 17.945 0.211426C27.3435 0.211426 34.9202 7.86168 34.9202 17.3383C34.9202 26.8148 27.3435 34.4651 17.945 34.4651ZM17.9658 29.5949C25.1698 29.5949 28.3785 23.1825 28.3785 17.3383C28.3785 11.1085 24.5281 5.08162 17.9658 5.08162C11.362 5.08162 7.51156 11.1085 7.51156 17.3383C7.51156 23.1825 10.7203 29.5949 17.9658 29.5949ZM34.2577 41.7907V39.3759C35.6447 38.0569 40.6545 33.9578 40.6545 31.2995C40.6545 29.9602 39.4538 29.3514 38.2324 29.3514C36.9903 29.3514 35.8103 29.879 34.8374 30.5081L34.6097 28.0933C35.9345 27.4439 37.4872 27.0584 38.9776 27.0584C41.793 27.0584 43.6148 28.4585 43.6148 31.2995C43.6148 34.3636 40.4682 37.1843 38.0461 39.5179H44.0909V41.7907H34.2577Z",
    fill: "#0066FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO2Uk);
export default __webpack_public_path__ + "static/media/O2UK.68946a96288f3a7d4497cc97113dc414.svg";
export { ForwardRef as ReactComponent };